import React from 'react';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export default function PivotList({
    rows,
    selectedItems,
    onToggleItem,
    onToggleFavorite,
    hasStockData,
    hideDecimals = false,
    totemMode = false,
}) {
    const isSelected = (id) => selectedItems.includes(id);

    // Higher-contrast alternating backgrounds
    const bgColors = ['#ffffff', '#f7fbff'];
    // Lighter accent colors that blend with the light palette
    const accentColors = ['#eef6ff', '#eaf4ff'];

    const formatTotemPrice = (retailPrice) => {
        if (retailPrice == null) return 'N/A';
        const num = parseFloat(retailPrice);
        return '$ ' + num.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    };

    return (
        <div>
            {Array.isArray(rows) && rows.map((row, idx) => {
                const bg = bgColors[idx % bgColors.length];
                const accent = accentColors[idx % accentColors.length];
                return (
                    <Paper key={row.ProductId || idx} sx={{ mb: 2, p: 2, background: bg }} elevation={0}>
                        {totemMode ? (
                            <Box sx={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: 2, alignItems: 'center' }}>
                                {/* Column 1: Brand + Description */}
                                <Box>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 0.5 }}>{row.BrandName || '-'}</Typography>
                                    <Typography variant="body2" sx={{ mb: 0.5 }}><strong>Descripcion</strong></Typography>
                                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>{row.ProductDescription || '-'}</Typography>
                                </Box>
                                {/* Column 2: Codigo */}
                                <Box>
                                    <Typography variant="body2"><strong>Codigo</strong></Typography>
                                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>{row.ProductCode || '-'}</Typography>
                                </Box>
                                {/* Column 3: Precio */}
                                <Box>
                                    <Typography variant="body2"><strong>Precio</strong></Typography>
                                    <Typography sx={{ fontWeight: 700, fontSize: '2em', color: 'text.primary' }}>
                                        {formatTotemPrice(row.RetailPrice)}
                                    </Typography>
                                </Box>
                            </Box>
                        ) : (
                            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
                                <Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                        <Checkbox
                                            color="primary"
                                            checked={isSelected(row.ProductId)}
                                            onClick={(e) => { e.stopPropagation(); onToggleItem(row.ProductId, !isSelected(row.ProductId)); }}
                                        />
                                        <Tooltip title={row.IsFavorite ? 'Quitar de favoritos' : 'Agregar a favoritos'}>
                                            <IconButton size="small" onClick={(e) => { e.stopPropagation(); onToggleFavorite(row.ProductId, row.IsFavorite); }}>
                                                {row.IsFavorite === true ? <StarIcon /> : <StarBorderIcon />}
                                            </IconButton>
                                        </Tooltip>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>{row.BrandName || '-'}</Typography>
                                    </Box>
                                    <Typography variant="body2" sx={{ mb: 0.5 }}><strong>Descripcion</strong></Typography>
                                    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>{row.ProductDescription || '-'}</Typography>
                                </Box>
                                <Box>
                                    <Typography variant="body2"><strong>Codigo</strong></Typography>
                                    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 0.8 }}>{row.ProductCode || '-'}</Typography>
                                    <Typography variant="body2"><strong>EAN</strong></Typography>
                                    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 0.8 }}>{row.EAN || '-'}</Typography>
                                    <Typography variant="body2"><strong>Precio</strong></Typography>
                                    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 0.8 }}>{`$ ${row.RetailPrice != null ? parseFloat(row.RetailPrice).toFixed(hideDecimals ? 0 : 2) : 'N/A'}`}</Typography>
                                    {hasStockData && (
                                        <>
                                            <Typography variant="body2"><strong>Un.</strong></Typography>
                                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>{row.IndividualUnitCount != null ? row.IndividualUnitCount.toLocaleString('es-AR') : '-'}</Typography>
                                        </>
                                    )}
                                </Box>
                            </Box>
                        )}
                    </Paper>
                );
            })}
        </div>
    );
}
